module.exports = __webpack_public_path__ + "src/img/zalando/img-iphones-reviews-process.2a67b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-iphones-reviews-process.jpg
// module id = 125
// module chunks = 0